import { render, staticRenderFns } from "./economicGraph.vue?vue&type=template&id=49d36452"
import script from "./economicGraph.vue?vue&type=script&lang=js"
export * from "./economicGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports